module.exports = __webpack_public_path__ + "img/icon-notice-off.383ffd57.svg";